/**
 * FedRAMP readiness rule set — V103-6-5 / ADR-0068 §4 (migration 341).
 *
 * Which readiness engine `fedramp-cr26` runs is reviewed data, not code: the
 * program's current approved `program_rule_sets` row of family
 * `fedramp-readiness` names it. v1 (341) is `{"engine":"objective", …}`; a
 * revert is approving the next version `{"engine":"ksi"}` — append-only, no
 * deploy. With no approved row the manifest's `legacyEngine` (`ksi`) runs.
 *
 * The same rule set carries the FRC-CSX-VVK automated-method minimums per
 * class (owner decision 6, 2026-10-06): the rule text states them in prose
 * ("at least 1 / 2 / 4 automated methods"), so they are restated here as
 * reviewed values with the rule id and release they come from.
 */
import { z } from 'zod';
export const FEDRAMP_READINESS_FAMILY = 'fedramp-readiness';
export const FEDRAMP_READINESS_SCHEMA = 'gacpro.program-rules.fedramp-readiness/1';
const ClassMinimum = z.object({
    minimum: z.number().int().min(0).max(20),
    force: z.enum(['MAY', 'SHOULD', 'MUST']),
}).strict();
export const FedrampReadinessRulesV1 = z.object({
    engine: z.enum(['objective', 'ksi']),
    automated_validation: z.object({
        rule_id: z.literal('FRC-CSX-VVK'),
        source_version: z.string().trim().min(1).max(40),
        classes: z.object({ A: ClassMinimum, B: ClassMinimum, C: ClassMinimum, D: ClassMinimum }).strict(),
    }).strict().optional(),
}).strict();
/** The FRC-CSX-VVK minimum for a class, and how a shortfall counts: SHOULD → gap, MUST → blocker, MAY → none. */
export function automatedMethodMinimum(rules, cls) {
    const c = cls && rules?.automated_validation ? rules.automated_validation.classes[cls] : undefined;
    if (!c)
        return null;
    return { ...c, severity: c.force === 'MUST' ? 'blocker' : c.force === 'SHOULD' ? 'gap' : 'none' };
}
//# sourceMappingURL=fedramp-readiness-rules.js.map